export const IMPORT_DOCUMENT_VALUES_FORMAT_RULES = {
  rate: 'percentage',
  term: (value) => `${value} months`,
  arm_floor: 'percentage',
  DocumentID: 'hidden',
  arm_margin: 'percentage',
  close_date: 'date',
  pi_payment: 'currency',
  arm_ceiling: 'percentage',
  maturity_date: 'date',
  lat: 'hidden',
  lng: 'hidden',
  map: 'hidden',
  found: 'hidden',
  original: 'hidden',
  normalized: 'hidden',
  country_code: 'hidden',
  arm_sub_change_cap: 'percentage',
  first_payment_date: 'date',
  original_principal: 'currency',
  arm_sub_change_term: (value) => `${value} months`,
  mailbox_description: 'hidden',
  arm_first_change_cap: 'percentage',
  late_penalty_minimum: 'currency',
  late_penalty_percent: 'percentage',
  arm_first_change_term: (value) => `${value} months`,
  document_type: 'hidden',
  number: 'hidden',
  street: 'hidden',
  country: 'hidden',
  borrower_id: 'hidden',
  coborrower_id: 'hidden',
  agent_id: 'hidden',
  carrier_id: 'hidden',
  broker_id: 'hidden',

  // PAYMENT_LETTER fields
  date: 'date',
  pi_amount: 'currency',
  tax_amount: 'currency',
  total_payment: 'currency',
  insurance_amount: 'currency',
  servicing_fee_amount: 'currency',

  // SETTLEMENT fields
  escrow_insurance_amount: 'currency',
  escrow_tax_amount: 'currency',
  property_taxes_collected: 'currency',

  // SERVICING_SETUP fields
  bank_account_personal: {
    type: 'select',
    options: [
      { value: 'personal', label: 'Personal' },
      { value: 'business', label: 'Business' },
    ],
  },
  bank_account_type: {
    type: 'select',
    options: [
      { value: 'checking', label: 'Checking' },
      { value: 'savings', label: 'Savings' },
    ],
  },

  // INSURANCE_BINDER fields
  policy_premium: 'currency',
  statement_date: 'date',
  policy_start_date: 'date',
  policy_end_date: 'date',
  dwelling_coverage: 'currency',
  other_structure_coverage: 'currency',
  supplemental_coverage_amount: 'currency',
  deductible_hazard_amount: 'currency',
  deductible_hazard_percentage: 'percentage',
  deductible_wind_amount: 'currency',
  deductible_wind_percentage: 'percentage',
};

export const IMPORT_DOCUMENT_KEYS_FORMAT_MAP = {
  arm_floor: 'ARM floor',
  arm_index: 'ARM index',
  arm_margin: 'ARM margin',
  pi_payment: 'Principal and Interest payment',
  arm_sub_change_cap: 'ARM subsequent changes cap',
  arm_sub_change_term: 'ARM subsequent changes term',
  arm_first_change_cap: 'ARM first change cap',
  arm_first_change_term: 'ARM first change term',
  state_code: 'State',
  borrower_legal_designation: 'Borrower Legal Designation',
  borrower_tin_type: 'Borrower TIN type',
  borrower_mailing_address: 'Borrower mailing address',
  borrower_mailing_address_po_box: 'Borrower mailing address PO Box',
  coborrower_legal_description: 'Coborrower Legal Designation',
  coborrower_tin_type: 'Coborrower TIN type',
  pi_amount: 'Principal & Interest amount',
  address1: 'Address Line 1',
  address2: 'Address Line 2',

  // SETTLEMENT fields
  property_taxes_collected: 'Property Taxes Collected at Closing',

  // SERVICING_SETUP fields
  bank_account_name: 'Bank Account Owner',
  bank_name: 'Bank Name',
  bank_account_number: 'Account Number',
  bank_routing_number: 'Routing Number',
  bank_account_personal: 'Account Personal or Business',
  bank_account_type: 'Account Type',
  draft_day: 'ACH Draft Day',
  start_date: 'ACH First Payment Date',
  authorization_signed: 'ACH Authorization Signed',
  borrower_consent_signed: 'Borrower Consent Signed',
  fee_schedule_signed: 'Fee Schedule Signed',

  // INSURANCE_BINDER fields

  supplemental_coverage_amount: 'Supplemental Coverage',
  deductible_hazard_amount: 'Deductible Amount - Hazard',
  deductible_hazard_percentage: 'Deductible % - Hazard',
  deductible_wind_amount: 'Deductible Amount - Wind',
  deductible_wind_percentage: 'Deductible % - Wind',
};

export const IMPORT_DOCUMENT_NON_EDITABLE_FIELDS = {
  default: ['servicing_fee_amount'],
  SETTLEMENT: ['borrower', 'property_address'],
};

export const IMPORT_DOCUMENT_FIELDS_GROUPS = {
  NOTE: {
    Lender: ['lender'],
    Borrower: [
      'borrower',
      'borrower_legal_designation',
      'borrower_tin_type',
      [
        'borrower_mailing_address',
        ['address1', 'address2', 'city', 'state', 'zip', 'county'],
      ],
      'borrower_mailing_address_po_box',
    ],
    Coborrower: [
      'coborrower',
      'coborrower_legal_description',
      'coborrower_tin_type',
    ],
    Property: [
      [
        'property_address',
        ['address1', 'address2', 'city', 'state', 'zip', 'county'],
      ],
      'property_legal_description',
    ],
    'Note Overview': [
      'loan_number',
      'rate_type',
      'term',
      'close_date',
      'maturity_date',
      'first_payment_date',
      'payment_due_day',
      'rate',
      'original_principal',
      'pi_payment',
      'grace_period_days',
      'late_penalty_minimum',
      'late_penalty_percent',
    ],
    'ARM Terms': [
      'arm_index',
      'arm_margin',
      'arm_first_change_term',
      'arm_first_change_cap',
      'arm_sub_change_term',
      'arm_sub_change_cap',
      'arm_floor',
      'arm_ceiling',
    ],
  },
  SERVICING_SETUP: {
    'Bank Account Information': [
      'bank_account_name',
      'bank_name',
      'bank_account_number',
      'bank_routing_number',
      'bank_account_personal',
      'bank_account_type',
    ],
    'ACH Payment Schedule': ['draft_day', 'start_date'],
    Signatures: [
      'authorization_signed',
      'borrower_consent_signed',
      'fee_schedule_signed',
    ],
  },
  INSURANCE_BINDER: {
    Policy: [
      'policy_type',
      'named_insured',
      [
        'insured_address',
        ['address1', 'address2', 'city', 'state', 'zip', 'county'],
      ],
      'policy_number',
      'policy_premium',
      'statement_date',
      'policy_start_date',
      'policy_end_date',
      'dwelling_coverage',
      'other_structure_coverage',
      'supplemental_coverage_amount',
      'deductible_hazard_amount',
      'deductible_hazard_percentage',
      'deductible_wind_amount',
      'deductible_wind_percentage',
    ],
    Agent: [
      'agent',
      'agent_email',
      'agent_phone',
      [
        'agent_address',
        ['address1', 'address2', 'city', 'state', 'zip', 'county'],
      ],
      'agent_po_box',
    ],
    Carrier: [
      'carrier',
      [
        'carrier_address',
        ['address1', 'address2', 'city', 'state', 'zip', 'county'],
      ],
      'carrier_po_box',
    ],
    Broker: [
      'broker',
      [
        'broker_address',
        ['address1', 'address2', 'city', 'state', 'zip', 'county'],
      ],
      'broker_po_box',
    ],
    'First mortgagee': [
      'first_mortgagee',
      [
        'first_mortgagee_address',
        ['address1', 'address2', 'city', 'state', 'zip', 'county'],
      ],
    ],
    'Second mortgagee': [
      'second_mortgagee',
      [
        'second_mortgagee_address',
        ['address1', 'address2', 'city', 'state', 'zip', 'county'],
      ],
    ],
  },
};
